import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { handleKeyPress } from '../../../utilities/keyHandler'

const scope = 'BanBar'
export default class BanBar extends Component {
  static propTypes = {
    title: PropTypes.string,
    options: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
  }

  renderContent(option) {
    if (option.icon) {
      return (
        <Fragment>
          {option.icon}
          <span>{option.name}</span>
        </Fragment>
      )
    } else {
      return <Fragment>{option.name}</Fragment>
    }
  }

  render() {
    const { className, title, options, onSelect } = this.props
    return (
      <div className={classnames(scope, className)}>
        <div className={classnames(`${scope}-Title`)}>{title}</div>
        <div className={classnames(`${scope}-Options`)}>
          {options.map(option => (
            <div
              key={option.id}
              className={classnames(`${scope}-Option`)}
              title={option.title}
              onClick={() => onSelect(option.id)}
              tabIndex={0}
              onKeyPress={ev => handleKeyPress(ev, () => onSelect(option.id))}
            >
              {this.renderContent(option)}
            </div>
          ))}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ban-bar/ban-bar.jsx